<template lang="pug">
    div
        Card.a8-page-description-card
            Row(type="flex" align="middle" justify="space-between")
                    Col
                        h2 {{$t('owasp.pageTitleText')}}
                    Col
                        ExplainBtn(:objectExplanation="objectsExplanation")
            p Incoming traffic to your domain is first filtered by the ModSecurity Core Rule Set (CRS), which provides protection against a wide range of web application attacks. After initial filtering, additional WAF rules are applied to manage traffic based on various criteria such as location, IP address, User-Agent, URI, and more.
            strong You have created {{ usage.used }} of {{ usage.max }} OWASP.
        RcmTable(
            :esIndex="esIndex"
            :esIndexFields="esIndexFields"
            :addButtonText="addButtonText"
            :userCanCreate="true"
            :userCanIndex="true"
            :userCanDelete="true"
            :actionInTable="true"
            :userCanBatchEdit="false"
            :drawerTitleKey="drawerTitleKey"
            ref="rcmTable"
            :searchView="$options.name"
            drawerWidth="70"
            primarySearchKey="ruleName"
            :primarySearchKeyI18="$t('owasp.ruleName')"
            :isCreateBtnDisabled="!$can('write', 'domainManagePermission','owasp')"
            :isEditBtnDisabled="!$can('write', 'domainManagePermission','owasp')"
            :isDeleteBtnDisabled="!$can('write', 'domainManagePermission','owasp')"
            :submitConfirm="wafBucketSubmitConfirm"
            :deleteConfirm="wafBucketDeleteConfirm"
        )

</template>
<script>
import Vue from "vue";

import RcmTable from "@/components/RcmTable_v2";
import TagList from "@/components/TagList";
import bus from "@/libs/bus.js";

import CopyText from "@/components/CopyText";
import JsonPoptip from "@/components/JsonPoptip";
import ObjectLogBtn from "@/components/ObjectLogBtn";
import ExplainHotlink from "@/components/PoptipInfos/ExplainHotlink";

Vue.component("TagList", TagList);
Vue.component("CopyText", CopyText);
Vue.component("JsonPoptip", JsonPoptip);
Vue.component("ObjectLogBtn", ObjectLogBtn);
Vue.component("ExplainHotlink", ExplainHotlink);

import { ruleName, description, wafUri } from "./fields.js";
import { getGroupAsset } from "@/api/groupasset.js";
import { isWafBucketRule, getWafBucketNoticeKey } from "@/libs/wafBucket.js";

export default {
    name: "owasp",
    components: { RcmTable, TagList },
    data() {
        return {
            htmlPageRaw: {},
            showHtmlPreview: false,
            searchView: "owasp",
            esIndex: "rcm-owasprules",
            drawerTitleKey: "ruleName",
            sort: [{ modifiedDate: { order: "desc" } }],
            assetCategory: "owaspRules",
            usage: { used: "", max: "", available: "" },
            objectsExplanation: {},
        };
    },
    computed: {
        addButtonText() {
            return this.$i18n.t("domainsetting.createText");
        },
        esIndexFields() {
            return this.$store.getters.isAdmin
                ? {
                      action: {},
                      groupName: {},
                      ruleName: ruleName(this),
                      owaspThresholdLimit: {},
                      owaspParanoiaLevel: {},
                      owaspDetectRules: {},
                      wafAction: {},
                      wafDenyHtmlPageName: {},
                      wafIsDenyThenBucket: {},
                      wafDenyThenBucketRate: {},
                      wafSpeedLimit: {},
                      wafBucketTime: {},
                      wafBucketPreSslDeny: {},
                      wafBucketPreSslDenyThreshold: {},
                      wafIsGlobalBucketRecord: {},
                      wafWithL3BucketList: {},
                      wafSetReqHeaders: {},
                      wafSetResHeaders: {},
                      wafHotlinkSecretKey: {},
                      wafHotlinkTimeToLive: {},
                      wafHotlinkQueryArgument: {},
                      wafUri: wafUri(this),
                      wafOriginPolicyName: {},
                      wafRedirectUrl: {},
                      wafRedirectHttpCode: {},
                      wafCustomHtmlPageName: {},
                      //   wafHotlinkSecretKey: {},
                      //   wafHotlinkTimeToLive: {},
                      //   wafHotlinkQueryArgument: {},
                      description: description(this),
                      status: {},
                      objectLog: {},
                  }
                : {
                      action: {},
                      groupName: {},
                      ruleName: ruleName(this),
                      owaspThresholdLimit: {},
                      owaspParanoiaLevel: {},
                      owaspDetectRules: {},
                      wafAction: {},
                      wafDenyHtmlPageName: {},
                      wafIsDenyThenBucket: {},
                      wafDenyThenBucketRate: {},
                      wafSpeedLimit: {},
                      wafBucketTime: {},
                      wafBucketPreSslDeny: {},
                      wafBucketPreSslDenyThreshold: {},
                      wafIsGlobalBucketRecord: {},
                      wafWithL3BucketList: {},
                      wafSetReqHeaders: {},
                      wafSetResHeaders: {},
                      wafHotlinkSecretKey: {},
                      wafHotlinkTimeToLive: {},
                      wafHotlinkQueryArgument: {},
                      wafUri: wafUri(this),
                      wafOriginPolicyName: {},
                      wafRedirectUrl: {},
                      wafRedirectHttpCode: {},
                      wafCustomHtmlPageName: {},
                      //   wafHotlinkSecretKey: {},
                      //   wafHotlinkTimeToLive: {},
                      //   wafHotlinkQueryArgument: {},
                      description: description(this),
                      status: {},
                      objectLog: {},
                  };
        },
    },
    watch: {
        "$store.state.rcmTableIsInitComplete": function (newVal, oldVal) {
            if (this.$router.currentRoute.query.create && newVal) {
                this.$refs.rcmTable.manipulateItem("", "create");
            }
        },
        "$i18n.locale": {
            deep: true,
            handler: function () {
                this.objectsExplanation = this.$i18n.t("objectExplanation." + this.esIndex);
            },
        },
    },
    methods: {
        // OWASP 規則同樣可設定 Block Period／Deny 觸發 Period 阻擋，
        // 變更時後端會一併清除既有水桶，送出前先提示使用者
        // 依「變更前」的規則判斷，才涵蓋 wafAction 由 Block Period 改成其他動作的情況
        // 內容完全沒有變更時不提示，與後端不清除的條件一致
        wafBucketSubmitConfirm({ originalItem, isUnchanged }) {
            if (isUnchanged || !isWafBucketRule(originalItem)) return "";
            return this.$t(getWafBucketNoticeKey(originalItem, "edit"));
        },
        // 刪除有水桶的規則時，後端會一併清除該規則現有的水桶紀錄
        wafBucketDeleteConfirm(row) {
            if (!isWafBucketRule(row)) return "";
            return this.$t(getWafBucketNoticeKey(row, "delete"));
        },
        getAssetData() {
            getGroupAsset({
                category: this.assetCategory,
                groupNames: [this.$store.state.queryGroupName],
            }).then((res) => {
                let { used, max } = res.data;
                let available = max - used;
                this.usage = { used, max, available };
            });
        },
    },
    mounted() {
        this.getAssetData();
    },
    created() {
        this.objectsExplanation = this.$i18n.t("objectExplanation." + this.esIndex);
        // this.isAdmin = this.$store.state.userData.privilege == "admin";
        this.$bus = bus;
        // 監聽以自己組件為名的事件
        bus.$on(this.$options.name, (busEvent, args) => {
            // 如果是找我的事件就接收處理, 否則向下傳遞
            switch (busEvent) {
                case "":
                    break;
                default:
                    bus.$emit(busEvent);
                    break;
            }
        });
    },
    destroyed() {},
    beforeDestroy() {
        bus.$off(this.$options.name);
    },
};
</script>



// WEBPACK FOOTER //
// src/view/OWASP/Page.vue